import { useTranslation } from "react-i18next";

import { useConfigSettings } from "../useConfigSettings";

export const useRegFormSettings = () => {
  const { t } = useTranslation();
  const { regForm, showTermsOfService, disabledComponents, signupByInvite } = useConfigSettings();
  const {
    title,
    login,
    email,
    password,
    confirmPassword,
    familyName,
    name,
    surname,
    company,
    phone,
    goals,
    terms,
    button,
    signIn,
  } = regForm || {};

  return {
    title: title || (signupByInvite ? t("getAccess") : t("regTitle")),
    login: login || t("login"),
    email: email || t("email"),
    familyName: familyName || t("familyName"),
    name: name || t("name"),
    surname: surname || t("surname"),
    password: password || t("password"),
    confirmPassword: confirmPassword || t("confirmPassword"),
    company: company || t("company"),
    phone: phone || t("phone"),
    goals: goals || t("goals"),
    button: button || t("signUp"),
    signIn: signIn || t("signIn"),
    terms,
    showTermsOfService,
    disabledComponents,
    signupByInvite,
  };
};
